(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino-react/quick-search-pills/assets/javascripts/quick-search-pills.js') >= 0) return;  svs.modules.push('/components/casino-react/quick-search-pills/assets/javascripts/quick-search-pills.js');

'use strict';

const searchTerms = svs.casino_react.shared.data.cmsPopularSearchTerms;
const _svs$ui = svs.ui,
  Button = _svs$ui.ReactButton,
  Icon = _svs$ui.ReactIcon;
const useSetSearchParams = svs.components.casino_react.hooks.useSetSearchParams;
const QuickSearchPills = () => {
  const _useSetSearchParams = useSetSearchParams(),
    setQuery = _useSetSearchParams.setQuery;
  if (!searchTerms.length) {
    return null;
  }
  return React.createElement("div", {
    className: "quick-search-pills"
  }, searchTerms.map(term => React.createElement(Button, {
    className: "quick-search-pills__pill",
    iconPosition: "left",
    key: term,
    onClick: () => setQuery(term),
    rounded: true
  }, React.createElement(Icon, {
    icon: "search"
  }), term)));
};
setGlobal('svs.components.casino_react.quickSearchPills.QuickSearchPills', QuickSearchPills);

 })(window);